import FCL_REG from '../data/fclRuleset';   // uretilmis — kaynak: ruleset-fcl/
import { overrideDirection } from './FTLEngine';

// FTL KURAL KATALOGU — "MOTOR NE UYGULUYORSA EKRANDA YAZAR"
//
// 🔑 SERKAN (3 Eyl 2026): *"Bizim FTL modulde ne rule varsa onlar rule sette
//  yazmali; regulasyondan gelen ve bizim belirlediklerimiz COMPANY ve SHT
//  olarak ayrismali."* ve *"SHT'den gelenler regulasyona bagli — sayet SHT
//  degisirse bu kural degisebilir, sirket bunu ancak DARALTABILIR, gevsetemez.
//  Hangi SHT talimati ise ref. onu da gostermeliyiz, rev numarasi varsa onu da
//  ekleyerek."*
//
// 🔴 OLCULEN ACIK (3 Eyl): mevzuat blogunda **91 ayar** var, RULESET ekrani
// **13** tanesini gosteriyordu. FDP limitlerinin KENDISI, uzun menzil, takviye
// ekip, bolunmus gorev, komutan takdiri, nobet, bildirim sureleri ve intibak
// ekranda HIC YOKTU — motor uyguluyor ama kimse goremiyor.
//
// ┌ IKI KAYNAK, IKI DAVRANIS ──────────────────────────────────────────────┐
// │ SHT     : kaynak talimattan gelir. Kunye + revizyon GORUNUR.           │
// │           Sirket yalniz DARALTABILIR (`decrease_only`), gevsetemez.     │
// │ COMPANY : mevzuatta karsiligi olmayan (ferry) ya da sirket ek kisiti.   │
// │           Serbestce duzenlenir.                                         │
// └────────────────────────────────────────────────────────────────────────┘
//
// 🔑 ETIKET UYDURULMAZ: bilinen yollar icin insan okunur ad yazilir, BILINMEYEN
// yol icin YOLUN KENDISI gosterilir. Boylece mevzuata yeni bir alan eklendiginde
// ekranda SESSIZCE KAYBOLMAZ — cirkin ama gorunur olur (Ilke 1).

/** Insan okunur adlar. Eksik olan yol, YOLU ile gosterilir — gizlenmez. */
const ETIKET = {
  'fdp_limits.general_aviation.single': 'MAX FDP — GENERAL AVIATION, SINGLE PILOT',
  'fdp_limits.general_aviation.dual': 'MAX FDP — GENERAL AVIATION, DUAL PILOT',
  'fdp_limits.training.max_fdp': 'MAX FDP — TRAINING',
  'long_range.tz_crossing_hours_min': 'LONG RANGE — TIME ZONES CROSSED (H)',
  'long_range.max_daily_fdp': 'LONG RANGE — MAX DAILY FDP',
  'long_range.return_rest_min_hours': 'LONG RANGE — REST ON RETURN TO BASE (H)',
  'long_range.return_local_nights': 'LONG RANGE — LOCAL NIGHTS ON RETURN',
  'augmented_crew.max_sectors': 'AUGMENTED CREW — MAX SECTORS',
  'augmented_crew.inflight_rest_each_min': 'AUGMENTED CREW — IN-FLIGHT REST EACH',
  'augmented_crew.extension_one_additional_min': 'AUGMENTED — EXTENSION, 1 EXTRA PILOT',
  'augmented_crew.extension_two_additional_min': 'AUGMENTED — EXTENSION, 2 EXTRA PILOTS',
  'split_duty.break_threshold_min': 'SPLIT DUTY — BREAK THRESHOLD',
  'split_duty.extension_cap_min': 'SPLIT DUTY — EXTENSION CAP',
  'cumulative_limits.duty_7d_min': 'MAX DUTY — 7 DAYS',
  'cumulative_limits.duty_14d_min': 'MAX DUTY — 14 DAYS',
  'cumulative_limits.duty_28d_min': 'MAX DUTY — 28 DAYS',
  'cumulative_limits.duty_cal_year_min': 'MAX DUTY — CALENDAR YEAR',
  'cumulative_limits.flt_28d_min': 'MAX FLT — 28 DAYS',
  'cumulative_limits.flt_12mo_min': 'MAX FLT — 12 MONTHS',
  'min_rest.home_base_min': 'MIN REST — HOME BASE',
  'min_rest.out_of_base_min': 'MIN REST — OUT OF BASE',
  'min_rest.out_of_base_sleep_opportunity_min': 'MIN REST — SLEEP OPPORTUNITY OUT OF BASE',
  'min_rest.tz4_rotation_out_of_base_min': 'MIN REST — AFTER 4+ TZ ROTATION',
  'commander_discretion.fdp_extension_max_min': 'SKPK — MAX FDP EXTENSION',
  'commander_discretion.fdp_extension_augmented_max_min': 'SKPK — MAX FDP EXTENSION, AUGMENTED',
  'commander_discretion.rest_reduction_max_min': 'SKPK — MAX REST REDUCTION',
  'commander_discretion.rest_floor_min': 'SKPK — REST FLOOR',
  'commander_discretion.authority_report_over_min': 'SKPK — AUTHORITY REPORT OVER',
  'days_off.single_day_off_after_consecutive_days': 'DAY OFF AFTER — CONSECUTIVE DAYS',
  'days_off.per_calendar_month_local_days': 'MIN OFF — LOCAL DAYS / MONTH',
  'days_off.per_calendar_year_local_days': 'MIN OFF — LOCAL DAYS / YEAR',
  'days_off.notice_hours': 'DAYS OFF — NOTICE (H)',
  'days_off.local_night_start': 'LOCAL NIGHT — START',
  'days_off.local_night_end': 'LOCAL NIGHT — END',
  'days_off.local_night_length_hours': 'LOCAL NIGHT — FREE HOURS NEEDED',
  'standby.airport.fdp_reduction_after_min': 'AIRPORT STANDBY — FDP REDUCTION AFTER',
  'standby.airport.standby_plus_fdp_cap_min': 'AIRPORT STANDBY — STANDBY + FDP CAP',
  'standby.other.max_min': 'OTHER STANDBY — MAXIMUM',
  'standby.other.duty_credit_ratio': 'OTHER STANDBY — DUTY CREDIT RATIO',
  'standby.other.fdp_reduction_after_min': 'OTHER STANDBY — FDP REDUCTION AFTER',
  'notification_times.preflight_report_min': 'PRE-FLIGHT REPORT',
  'notification_times.postflight_min': 'POST-FLIGHT DUTY',
  'notification_times.postflight_sim_training_min': 'POST-SIM DEBRIEFING',
  'acclimatisation.band_tolerance_min': 'ACCLIMATISATION — BAND TOLERANCE',
  'acclimatisation.rest_threshold_min': 'ACCLIMATISATION — REST THRESHOLD',
};

/** Gosterilmeyecek anahtarlar: kunye ve serbest not — ayar degil. */
const ATLA = new Set(['reference', 'note', 'notes', 'scope', 'style', 'source']);

/** Bir blogun butun yapraklarini cikarir. Dizi ve nesne YAPISAL sayilir:
 *  gosterilir ama duzenlenmez — sayiya indirgemek bilgiyi kaybettirirdi. */
function yapraklar(nesne, onek, ustKunye = null) {
  const cikti = [];
  // 🔑 KUNYE SATIRIN KENDISINE AITTIR, BLOGA DEGIL.
  // Olculdu (3 Eyl 2026): `fdp_limits` blogunun kendi `reference`i YOK; kunye
  // bir alt katta, HER UCUS TIPININ altinda duruyor (air_taxi→Md.22(2),
  // general_aviation→Md.25, training→Md.27). Blok seviyesinde bakinca en
  // onemli blogun 40 satiri "madde metni bulunamadi" diyordu. Bu yuzden en
  // yakin UST dugumun kunyesi asagi tasinir.
  const gez = (o, yol, kunye) => {
    if (Array.isArray(o)) { cikti.push({ path: yol, value: o, yapisal: true, reference: kunye }); return; }
    if (o && typeof o === 'object') {
      const k2 = o.reference || kunye;
      Object.entries(o).forEach(([k, v]) => { if (!ATLA.has(k)) gez(v, yol ? `${yol}.${k}` : k, k2); });
      return;
    }
    // `enforcement` gibi meta bloklarda kunye degerin KENDI metnindedir
    // ("Md.22(2) Tablo 1 — ..."); onu da kabul ederiz, uydurmak yerine.
    const kendi = (typeof o === 'string' && /Md\.\s*\d+/.test(o)) ? o : null;
    cikti.push({ path: yol, value: o, yapisal: false, reference: kendi || kunye });
  };
  gez(nesne, onek, ustKunye);
  return cikti;
}

/** Sayisal VE yonu ACIKCA tanimli mi?
 *  🔑 `'locked'` = yonu yazilmamis mevzuat parametresi → DUZENLENEMEZ.
 *  Hangi yonun daralttigini bilmedigimiz yerde tahminle degistirmeyiz;
 *  yanlis yon mevzuati GEVSETIR (Ilke 7). Yon eklemek bilincli bir istir. */
export function duzenlenebilirMi(path, value) {
  if (typeof value !== 'number' && !/^\d{1,2}:\d{2}$/.test(String(value))) return false;
  const dir = overrideDirection(path);
  return dir === 'decrease_only' || dir === 'increase_only';
}

/**
 * SHT bloklarini ekrana hazir hale getirir.
 * @returns [{ key, reference, rows: [{path,label,value,editable,direction,structural}] }]
 */
export function shtBloklari(regulation) {
  const reg = regulation || {};
  return Object.entries(reg)
    .filter(([, v]) => v && typeof v === 'object' && !Array.isArray(v))
    .map(([key, blok]) => ({
      key,
      reference: blok.reference || null,
      rows: yapraklar(blok, key, blok.reference || null).map(({ path, value, yapisal, reference }) => ({
        path,
        reference,
        label: ETIKET[path] || path,
        etiketsiz: !ETIKET[path],
        value,
        structural: yapisal,
        editable: !yapisal && duzenlenebilirMi(path, value),
        direction: overrideDirection(path),
      })),
    }))
    .filter(b => b.rows.length > 0);
}

/** Talimatin kunyesi + revizyonu — ekranda basligin altinda durur. */
export function kaynakKunyesi(ruleset) {
  const reg = ruleset?.regulation || {};
  return {
    reference: reg.reference || null,
    revision: reg.revision
      || (String(reg.reference || '').match(/Rev\s*\d+/i) || [null])[0],
    name: ruleset?.name || null,
    engine: ruleset?.engine_type || null,
  };
}

/** SIRKET kurallari — mevzuatta karsiligi OLMAYANLAR ve ek kisitlar. */
export function sirketKurallari(ruleset) {
  const c = ruleset?.company || {};
  return [
    { key: 'pre_flight_report_minutes', label: 'PRE-FLIGHT REPORT (ETD−) MIN', value: c.pre_flight_report_minutes ?? null },
    { key: 'post_flight_duty_minutes', label: 'POST-FLIGHT DUTY (ON BLK+) MIN', value: c.post_flight_duty_minutes ?? null },
    { key: 'mandatory_report_hours', label: "COMMANDER'S SKPK REPORT TO OPERATOR — DEADLINE (H)",
      value: c.mandatory_report_hours ?? null,
      note: 'Md.12(c)(1) requires the commander to submit a report to the OPERATOR whenever an FDP '
          + 'is extended or a rest period reduced, but sets NO deadline for it. This hour figure is '
          + 'the operator\'s own deadline. The regulatory deadlines are separate and live under SHT: '
          + 'the report goes to the DGCA when the extension/reduction exceeds 1 hour (Md.12(c)(2)), '
          + 'within 28 days. Left empty, no operator deadline is computed — nothing is assumed (since 5 OCT 2026; '
          + 'before, an empty field was silently taken as 72 hours).' },
    { key: 'min_off_days_per_month', label: 'MIN OFF DAYS / MONTH', value: c.min_off_days_per_month ?? null },
    { key: 'ferry.of', label: 'FERRY — CANDIDATE OPERATION TYPES',
      value: c.ferry?.of ?? null,
      note: 'SHT-FTL/HG has no ferry category. A ferry can follow either a commercial or a '
          + 'general aviation flight, so the tightest limit among these types is applied.' },
  ];
}

// ── FCL KURAL SETİ (4 Eyl 2026, Serkan) ─────────────────────────────
//
// 🔑 Serkan: *"Rule set'e FCL içinde bir tablo koyacaz, i işareti de olacak."*
//
// ⚠️ FCL, FTL'DEN AYRI BİR MEVZUATTIR. SHT-FTL/HG görev ve dinlenme sınırlarını
//    düzenler; SHT-FCL lisans ve yetki geçerliliğini. İkisini aynı tabloya
//    koymak "hangi kural nereden" sorusunu bulanıklaştırırdı — ekranda da,
//    FTL Limits / FCL Limits barlarında da ayrı duruyorlar.
//
// ⚠️ KAYNAK VERİTABANI DEĞİL, PAKETLENMİŞ DOSYA. SHT-FTL/HG kural seti
//    müşteriye göre değişir (şirket daraltabilir) ve `ftl_rulesets` satırında
//    durur. FCL ise mevzuat metnidir, müşteriden müşteriye değişmez —
//    `ruleset-fcl/ruleset_fcl_regulation.json` uygulamayla birlikte gelir.
//    (CRA `src/` disindan import'a izin vermedigi icin `src/data/fclRuleset.js`
//     olarak TURETILIR — `python3 ops/gen_fcl_articles.py`. Kopya degil, cikti.)

/** SHT-FCL bloklarını ekrana hazır hale getirir (shtBloklari'nin kardeşi). */
export function fclBloklari() {
  const kok = FCL_REG.recent_experience || {};
  return Object.entries(kok)
    .filter(([, v]) => v && typeof v === 'object' && !Array.isArray(v))
    .map(([key, blok]) => ({
      key,
      reference: blok.reference || null,
      note: blok.note || null,
      rows: yapraklar(blok, key, blok.reference || null)
        .filter(({ path }) => !path.endsWith('.note') && !path.endsWith('.reference'))
        .map(({ path, value, yapisal, reference }) => ({
          path, reference, value, structural: yapisal,
          label: ETIKET[path] || path.split('.').slice(1).join(' · ').replace(/_/g, ' ').toUpperCase(),
          etiketsiz: !ETIKET[path],
          editable: false,          // mevzuat metni — şirket değiştiremez
          direction: 'locked',
        })),
    }))
    .filter(b => b.rows.length > 0);
}

/** FCL künyesi: talimatın adı ve değişiklik numarası. */
export function fclKunyesi() {
  return { reference: FCL_REG.reference || null, revision: FCL_REG.revision || null,
           issued: FCL_REG.issued || null, scope: FCL_REG.scope || null };
}

/** SHT-FCL'de karşılığı olmayan ya da metnin AÇIK BIRAKTIĞI operatör kararları. */
export function fclSirketKurallari() {
  const c = FCL_REG.company || {};
  return Object.entries(c)
    .filter(([k, v]) => k !== 'note' && v && typeof v === 'object')
    .map(([key, v]) => ({
      key, label: v.label || key.replace(/_/g, ' ').toUpperCase(),
      value: v.value !== undefined ? v.value
        : (v.amber_from_days != null ? `amber ${v.amber_from_days}d · red ${v.red_from_days}d` : null),
      options: v.options || null, reference: v.reference || null, note: v.note || null,
    }));
}

/** Gece/gündüz tanımı — ölçünün dayandığı madde. */
export function fclGeceTanimi() { return FCL_REG.night_definition || null; }

/** Ölçebildiklerimiz / ölçemediklerimiz — İlke 1 gereği ekranda yazar. */
export function fclOlculebilirlik() { return FCL_REG.measurability || null; }
